import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=35b7b328&scoped=true&lang=pug&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=35b7b328&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7b328",
  null
  
)

export default component.exports